<template>
  <ValidationObserver v-slot="{ handleSubmit, failed }" class="login__box" tag="div">
    <div class="login__box__welcome"></div>

    <div v-if="!registrationComplete">
      <form @submit.prevent="handleSubmit(submitForm)">
        <div class="login__box__input-description">Email</div>
        <ValidationProvider
          mode="lazy"
          name="Email"
          rules="email|required"
          v-slot="{ failed, errors }"
        >
          <input
            type="text"
            class="login__box__input-email"
            placeholder="email@email.cz"
            :class="{ error: failed }"
            v-model="form.email"
          />
          <p class="validate-warn" v-if="errors[0]">{{ errors[0] }}</p>
        </ValidationProvider>
        <div class="login__box__input-description">Username</div>
        <ValidationProvider
          rules="englishAlpha|required"
          v-slot="{ failed, failedRules }"
        >
          <input
            type="text"
            class="register__box__input-nickname"
            :class="{ error: failed }"
            placeholder="username"
            v-model="form.username"
          />
          <p class="validate-warn" v-if="failedRules.englishAlpha">
            {{ failedRules.englishAlpha }}
          </p>
        </ValidationProvider>

        <div class="login__box__input-description">Password</div>
        <ValidationProvider name="heslo" rules="required" v-slot="{ failed }">
          <input
            type="password"
            class="login__box__input-password"
            :class="{ error: failed }"
            placeholder="password"
            v-model="form.password"
          />
        </ValidationProvider>

        <div class="login__box__input-description">Password again</div>
        <ValidationProvider
          rules="required|password:@heslo"
          v-slot="{ failed, failedRules }"
        >
          <input
            type="password"
            class="login__box__input-password"
            :class="{ error: failed }"
            placeholder="password again"
            v-model="form.confirmPassword"
          />
          <p class="validate-warn" v-if="failedRules.password">
            {{ failedRules.password }}
          </p>
        </ValidationProvider>

        <div class="register__box__register">
          <button :class="{ disabled: failed }" class="button">Register</button>
        </div>

        <router-link to="/">
          <div class="register__box__login">
            <button class="button">Login</button>
          </div>
        </router-link>
        <div class="clearfix"></div>
      </form>
    </div>

    <div v-else>
      <br />Registration has been successful. Please check your email inbox for activation
      link.
    </div>
  </ValidationObserver>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "RegisterBox",
  data() {
    return {
      registrationComplete: false,
      form: {
        email: "",
        username: "",
        password: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    ...mapActions({ register: "register" }),

    checkEmptyForm() {
      if (
        this.form.email == "" ||
        this.form.username == "" ||
        this.form.password == "" ||
        this.form.confirmPassword == ""
      ) {
        this.$toast.error(this.$t("messages.user-account.registration-empty-fields"));
        this.form.password = "";
        this.form.confirmPassword = "";
        return false;
      }
      return true;
    },

    checkPasswords() {
      if (this.form.password != this.form.confirmPassword) {
        this.$toast.error(
          this.$t("messages.user-account.registration-different-passwords")
        );
        this.form.password = "";
        this.form.confirmPassword = "";
        return false;
      }
      return true;
    },

    async submitForm() {
      if (!this.checkEmptyForm() || !this.checkPasswords()) return false;
      if (this.form.username.length <= 3) {
        this.$toast.error(this.$t("messages.user-account.short-username"));
        return false;
      }
      await this.$store.dispatch("toggleLoader", true);
      try {
        await this.register(this.form);
        this.$toast.success(this.$t("messages.user-account.registration-success"));
        this.registrationComplete = true;
      } catch (e) {
        if (e.response.data.msg == "user-mng.register.email-exists") {
          this.$toast.error(this.$t("messages.user-account.registration-email-exists"));
        } else if (e.response.data.msg == "user-mng.register.username-exists") {
          this.$toast.error(
            this.$t("messages.user-account.registration-username-exists")
          );
        } else if (e.response.data.msg == "user-mng.pwd-policy-error") {
          this.$toast.error(this.$t("messages.user-account.registration-pwd-policy"));
        } else {
          this.$toast.error(
            this.$t("messages.user-account.registration-response", { msg: e })
          );
          window.console.log(e.response.data.msg);
          this.form.password = "";
          this.form.confirmPassword = "";
        }
      }
      await this.$store.dispatch("toggleLoader", false);
    },
  },
};
</script>

<style></style>
